<template>
  <div class="row-separator analysisGroup-table">
    <v-data-table
      :headers="tableHeaders"
      :items="analysisGroup"
      :disableSort="true"
      :itemsPerPage.sync="analysisGroup.length"
      :showExpand="true"
      :hideDefaultFooter="true"
      class="blocAnalysisGroup"
    >
      <template #expanded-item="props">
        <td
          :colspan="2"
        >
          <SimpleAnalysis
            :items="props.item.analysisTypes"
          />
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import SimpleAnalysis from './simpleAnalysis.vue';

export default {
    components: { SimpleAnalysis },
    props: {
        analysisGroup: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        tableHeaders() {
            return [
                'name',
                'ERPCode',
            ].map(header => ({
                text: header.length ? this.$t(`forms.labels.${header}`) : '',
                value: header,
            }));
        },
    },
};
</script>
<style lang="scss" scoped>
.history {
    border: 1px solid #BDC2D0;
    margin: 0 6rem;
}
</style>

<style lang="scss">
@media screen and (max-width: 600px) {
  .blocAnalysisGroup {
    .v-data-table__expanded__content {
        .v-data-table__mobile-row:nth-child(2)  {
          border-bottom: 1px solid #E0E0E0 !important;
        }
      }
  }
}
</style>
